import { render, staticRenderFns } from "./PersonInChargeProjects.vue?vue&type=template&id=8ac354be&scoped=true&"
import script from "./PersonInChargeProjects.vue?vue&type=script&lang=js&"
export * from "./PersonInChargeProjects.vue?vue&type=script&lang=js&"
import style0 from "./PersonInChargeProjects.vue?vue&type=style&index=0&id=8ac354be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac354be",
  null
  
)

export default component.exports